import React from 'react';
import { MailIcon, SettingsIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-gray-900 text-white py-12 mt-16" data-id="element-74">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-75">
        <div className="flex items-center justify-center gap-3 mb-4" data-id="element-76">
          <SettingsIcon className="w-8 h-8 text-emerald-400" data-id="element-77" />
          <h3 className="text-xl font-bold" data-id="element-78">Soporte</h3>
        </div>

        <p className="text-gray-300 mb-4" data-id="element-79">
          ¿Tenés alguna duda? Escribinos y te respondemos en menos de 24hs
        </p>

        <a href="mailto:EbookDreamShop@gmail.com" className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 transition-colors duration-200" data-id="element-80">
          <MailIcon className="w-5 h-5" data-id="element-81" />
          <span className="text-lg" data-id="element-82">EbookDreamShop@gmail.com</span>
        </a>

        <div className="mt-8 pt-8 border-t border-gray-700 text-sm text-gray-400" data-id="element-83">
          <p data-id="element-84">© 2026 Kit RRHH en Orden. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}